import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import DashboardHeader from './DashboardHeader';
import Error from 'components/Error';
import Pagination from 'components/common-components/Pagination';
import TableComponent from 'components/table-component/Table';
import { permissionKeys } from 'config/config';
import { isPermissionAvailable } from 'config/permissionUtils';
import { formsTableHeader } from './utils';
import { CallAPI } from 'actions/General';

const DashboardForms = ({ type }) => {
  const navigate = useNavigate();
  const condition = sessionStorage.getItem('dashboardFormListQuery')
    ? JSON.parse(sessionStorage.getItem('dashboardFormListQuery'))
    : null;

  const [allForms, setAllForms] = useState([]);
  const [totalForms, setTotalForms] = useState(0);
  const [currentPage, setCurrentPage] = useState(condition?.page ?? 1);
  const [displayEntries, setDisplayEntries] = useState(condition?.limit ?? 10);
  const [loader, setLoader] = useState(false);
  const [APIError, setAPIError] = useState('');
  const [searchText, setSearchText] = useState(condition?.searchText ?? '');
  const [searchTextData, setSearchTextData] = useState(condition?.searchText ?? '');
  const [selectedRows, setSelectedRows] = useState([]);
  const onRowsSelection = (name, value) => {
    let selectedIds = cloneDeep(selectedRows);
    if (name === 'all') {
      allForms.map((single_form) => {
        if (value && selectedIds.map((e) => e.id).indexOf(single_form._id) === -1)
          selectedIds.push({ id: single_form._id, title: single_form.title });
        if (!value) selectedIds = [];
        setSelectedRows(selectedIds);
      });
    } else {
      if (value) {
        let title = '';
        allForms.map((single_form) => {
          if (single_form._id === name) title = single_form.title;
        });
        selectedIds.push({ id: name, title: title });
      } else selectedIds.splice(selectedIds.map((e) => e.id).indexOf(name), 1);
      setSelectedRows(selectedIds);
    }
  };
  const getAllForms = async (page = 1, limit = 10) => {
    // let API = type === 'submittedForms' ? 'FETCH_SUPERVISOR_FORMS' : 'FETCH_FORMS';
    let API = 'FETCH_SUPERVISOR_FORMS';
    let result = await CallAPI(
      API,
      {
        screenTab: type === 'submittedForms' ? 'forms' : 'bookmarks',
        page: page,
        limit: limit,
        searchText: searchTextData,
        ...(condition ?? {}),
      },
      null,
      setLoader,
      setAPIError,
      null,
    );
    if (result.status) {
      sessionStorage.removeItem('dashboardFormListQuery');
      let formsList = [];
      result.data.forms.map((singleForm) => {
        formsList.push({
          ...singleForm,
          currentVersion: singleForm.currentVersion ? singleForm.currentVersion : {},
          publishedDate:
            singleForm.publishedVersion && singleForm.publishedVersion.publishedDate
              ? singleForm.publishedVersion.publishedDate
              : '',
        });
      });
      setAllForms(formsList);
      setTotalForms(result.data.totalCount);
    }
  };

  useEffect(() => {
    if (isPermissionAvailable(permissionKeys.view_data_dashboard_read)) {
      setSelectedRows([]);
      getAllForms();
    }
  }, [searchTextData, type]);

  const debouncedFunction = (name, value) => {
    setSearchTextData(value);
  };
  const searchTextChanged = (name, value) => {
    setCurrentPage(1);
    setDisplayEntries(10);
    setSearchText(value);
  };

  const changeDisplayEntries = (_, val) => {
    setCurrentPage(1);
    setDisplayEntries(parseInt(val));
    getAllForms(1, parseInt(val));
  };

  const formNameClickCallBack = (row) => {
    navigate('/submissions', {
      relative: 'path',
      state: {
        type: 'edit',
        formId: row._id,
        version: '',
        status: 'live',
        versionsList: row.versions,
      },
    });

    const formCondition = { page: currentPage, limit: displayEntries, searchText: searchTextData };
    sessionStorage.setItem('dashboardFormListQuery', JSON.stringify(formCondition));
  };

  return (
    <div>
      {APIError ? <Error msg={APIError} /> : <></>}
      <DashboardHeader
        searchTextChanged={searchTextChanged}
        searchText={searchText}
        debouncedFunction={debouncedFunction}
        type={type}
        actionsCallBack={getAllForms}
        selectedRows={selectedRows}
      />
      <TableComponent
        data={allForms}
        header={formsTableHeader}
        props={{
          type: 'dashboardForms',
          actionsType: 'dashboardForms',
          actionsCallBack: getAllForms,
          formNameClickCallBack,
        }}
        totalRecords={totalForms}
        filterEnabled={false}
        loader={loader}
        isFieldSelectionEnabled={false}
        isPaginationEnabled={false}
        isActionsEnabled={true}
        isSelectionEnabled={true}
        selectionKey={'_id'}
        onSelection={onRowsSelection}
        selectedRows={selectedRows}
      />
      {totalForms > 0 && (
        <Pagination
          totalRecords={totalForms}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          displayEntries={displayEntries}
          setDisplayEntries={changeDisplayEntries}
          currentPageRecords={allForms.length}
          paginationFunction={getAllForms}
        />
      )}
    </div>
  );
};
DashboardForms.propTypes = {
  type: PropTypes.string.isRequired,
};
export default DashboardForms;
